export const campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

// URL transport only: no storage, cookie, beacon or second attribution engine.
export function journeyUrl(target, current) {
    const url = new URL(target, current);
    const origin = new URL(current);
    if (url.origin !== origin.origin) return url;
    for (const key of campaignKeys) {
        const value = origin.searchParams.get(key);
        if (!url.searchParams.has(key) && value && value.length <= 200 && !/[\u0000-\u001f\u007f]/.test(value)) url.searchParams.set(key, value);
    }
    return url;
}
